module.exports = __webpack_public_path__ + "static/02-a123dd96c26ecd754a72011c7783fd46.jpg";